
<template>
    <div v-if="showModel" class="edit-model">
        <div class="img-div">
            <div>{{title}}</div>
            <div class="close-img" @click="cancel"><i class="iconfont">&#xe641;</i></div>
        </div>
       
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <Tabs type="card" v-model="tabIndex">
            <TabPane label="基本信息" name="1" value="1">
            <FormItem label="商品名称" prop="good_name">
                <Input type="text" v-model="formData.good_name"></Input>
            </FormItem>
            <FormItem label="缩略图" prop="thumb">
                <uploadImg	ref="upImg"	:action="action" :num="num"	:hasUpload="hasUpload"	@setThumbUrl="setSelected($event,'thumb')"></uploadImg>
            </FormItem>
            <FormItem label="轮播图" prop="good_images">
                <uploadImg  ref="imagesImg"  :action="action" :num="6"  @removeThumbUrl="removeImagesUrl"  @setThumbUrl="setImagesUrl"></uploadImg>
            </FormItem>

             <FormItem label="分享图片" prop="share_thumb">
                <uploadImg	ref="upImg_sha"	:action="action" :num="num"		@setThumbUrl="setSelected($event,'share_thumb')"></uploadImg>
            </FormItem>


            <FormItem label="状态" prop="status" class="ivu-form-item-required">
                <RadioGroup v-model="formData.status">
                    <Radio label="1">销售中</Radio>
                    <Radio label="2">已下架</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="兑换日期">
              <DatePicker type="daterange" :value="s_date" placement="bottom-end" placeholder="请选择兑换日期" @on-change="selectDate" style="width: 300px"></DatePicker>
            </FormItem>
            <FormItem label="消耗积分" prop="points">
                <Input type="text" v-model="formData.points"></Input>
            </FormItem>
            <FormItem label="库存" prop="stock">
                <Input type="text" v-model="formData.stock"></Input>
            </FormItem>
            <FormItem label="排序" prop="sort">
                <Input type="text" v-model="formData.sort"></Input>
            </FormItem>
            <FormItem label="商品描述" prop="des">
                <Input type="text" v-model="formData.des"></Input>
            </FormItem>
            <FormItem>
                <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
            </FormItem>
            </TabPane>
            <TabPane label="图文详情" name="2" value="2">
                <FormItem label="详情" prop="detail" class="ivu-form-item-required">
                    <NEditor
                        ref="nediter"
                        @setDetail="setSelected($event,'detail')"
                        :value="formData.detail"
                    ></NEditor>
                </FormItem>
                <FormItem>
                    <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
                </FormItem>
            </TabPane>
            
            </Tabs>
            
        </Form>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from "@/common/common";
import uploadImg from "@/views/common/upload.vue";
import NEditor from "@/views/common/neditor.vue";
export default {
  props: {
    showModel: Boolean,
    fn: Function,
    type: Number,
    editFormData: Object
  },
  name: "Model1",
  components: {
      uploadImg,
      NEditor
  },
  data() {
    return {
      //上传图片 start
      action: this.config.urlArray.commonUploadImage, //上传图片接口
      num: 1, //图片上传数量
      hasUpload: [], //已上传图片
      hasUploadSuc: [], //已上传图片
      hasUploadSha: [], //已上传图片
      //上传图片 end
      tabIndex:'1',
      title: "添加/编辑",
      disabled: false,
      s_date: [],
      defaultData: {
        id: "",
        good_name: "",
        thumb: "",
        good_images: [],
        status: "1",
        des: "",
        points: "",
        stock: "",
        sort: "100",
        start_time: '',
        end_time: '',
        detail:""
      },
      formData: {},
      ruleCustom: {
        //验证
        good_name: [{ required: true, message: "商品名称必须填写", trigger: "blur" }],
        thumb: [{ required: true, message: "缩略图称必须上传", trigger: "blur" }],
        good_images: [{ required: true, message: "请上传轮播图", trigger: "blur",  type: "array" }],
        des: [{ required: true, message: "描述必须填写", trigger: "blur" }],
        points: [{ required: true, message: "消耗积分必须填写", trigger: "blur" }],
        stock: [{ required: true, message: "库存必须填写", trigger: "blur" }],
        sort: [{ required: true, message: "排序必须填写", trigger: "blur" }],
        // detail: [{ required: true, message: "图文详情必须填写", trigger: "blur" }],
      }
    };
  },
  created(){
    if (this.type && this.type == 1) {
        this.formData = this.defaultData;
    }
  },
  watch: {
    showModel(val) {
      if (val) {
        if (this.type && this.type == 2) {
          this.editForm();
        }
        if (this.type && this.type == 1) {
          this.formData = this.defaultData;
        }
      }
    }
  },
  methods: {
    selectDate(d) {
      this.formData.start_time = d[0];
      this.formData.end_time = d[1];
    },
    setSelected(data, key) {
      console.log(data);
      this.formData[key] = data;
    },
    //上传商品相册
    setImagesUrl(url) {
      this.formData.good_images.push(url);
    },
    //移除商品相册
    removeImagesUrl(index) {
      this.formData.good_images.splice(index, 1);
    },
    editForm() {
      for (let key in this.defaultData) {
        this.formData[key] =  this.editFormData[key] instanceof Array ||  this.editFormData[key] instanceof Object ? this.editFormData[key] : String(this.editFormData[key]);
        if (!this.editFormData[key]) {
          this.formData[key] = "";
        }
        this.formData.timeArea = [this.formData.start_time,this.formData.end_time]
        this.formData.good_images = this.editFormData.good_images.split(',')
        this.$nextTick(() => {
            let thumbUpload = [{
            status:'finished',
            response:{data:this.formData.thumb}
            }]
            this.$refs.upImg.setHasUpload(thumbUpload)//为上传组件付默认值,封面
            
            if(this.formData.share_thumb){
              let thumbUpload = [{
              status:'finished',
              response:{data:this.formData.share_thumb}
              }]
              this.$refs.upImg_sha.setHasUpload(thumbUpload)//为上传组件付默认值,分享图片
            }


            //商品轮播图
            let imagesUpload = this.formData.good_images.map((item) => {
              // 处理规格数组的结构
              item = {
                status: "finished",
                name: "",
                response: { data: item },
              };
              return item;
            });
            this.$refs.imagesImg.setHasUpload(imagesUpload); //为上传组件付默认值

            if (this.formData.detail) {
                this.$refs.nediter.setEditer(this.formData.detail);
            }

        })
      }
      this.s_date = [
          this.editFormData.start_time,
          this.editFormData.end_time,
      ];

      console.log(this.formData)
    },
    subData(name) {
      //提交表单
      this.$refs[name].validate(valid => {
        if (valid) {
          this.disabled = true;
          this.axios
            .post(this.config.urlArray.goodStore, this.formData)
            .then(result => {
              common.ajaxMsg(
                result.data,
                true,
                () => {
                  //提交表单后的回调处理
                  this.resetForm(); //重置表单
                  this.fn();
                },
                () => {
                  this.disabled = false;
                }
              );
            })
            .catch(err => {
              common.msg("error", "提交失败", () => {
                this.disabled = false;
              });
            });
        }
      });
    },
    cancel() {
      //对话框关闭
      this.$emit("update:showModel", false);
      this.resetForm();
      this.fn();
    },
    setThumbUrl(url) {
      //获取图片上传后的路径
      this.formData.thumb = url;
    },
    resetForm() {
      this.formData = this.defaultData;
      //重置表单
      this.formData.id = '';
      this.$refs.formData.resetFields(); //重置表单
      this.disabled = false; //恢复提交按钮为激活状态
      this.tabIndex = '1'
    }
  }
};
</script>
<style lang='scss' scoped>
.edit-model {
  position: relative;
  .img-div {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 45px;
    div {
      font-weight: bold;
      font-size: 15px;
    }
  }
  .close-img {
    border: 1px solid #fd6363;
    display: inline-block;
    line-height: 100%;
    border-radius: 100%;
    padding: 5px;
    color: #f00;
    right: 10px;
    top: 10px;
    z-index: 3;
    cursor: pointer;
  }
  .close-img:hover {
    transform: scale(1.1);
    transition: all 0.3s;
  }
}
</style>